import { IDestroyOptions, Text, Texture } from "pixi.js";
import { ILatestNewsController } from "../../controllers/ILatestNewsController";
import { INewsItemOptions } from "./NewsItem";
import { NewsItemWithAvatar } from "./NewsItemWithAvatar";
import { TextWithUnderline } from "by/gamefactory/cityversetycoon/scenes/game/components/TextWithUnderline";
import { NewsTextStyle } from "../styles/NewsTextStyle";
import { CurrencyType, NewsCurrencyComponent } from "../NewsCurrencyComponent";
import { LatestNewsResourcePackage } from "../../resources/LatestNewsResourcePackage";
import { UserProfileResourcePackage } from "../../../userprofile/resources/UserProfileResourcePackage";
import { CancellationToken } from "async/CancellationToken";

export class NewsItemFixed extends NewsItemWithAvatar {
    private static readonly YOUVE_EARNED_TEXT = "YOU'VE EARNED";
    private static readonly FOR_YOUR_TEXT = 'FOR YOUR LAST FIX ACTION';
    private static readonly LEARN_MORE_TEXT = 'LEARN MORE';

    private readonly newsController: ILatestNewsController;
    private readonly options: NewsItemFixOptions;
    private readonly cancellationToken: CancellationToken;

    private youEarnedText: Text;
    private currencyComponent: NewsCurrencyComponent;
    private forYourLastText: Text;
    private learnMoreButtonText: TextWithUnderline;

    public constructor(
        id: string,
        newsResources: LatestNewsResourcePackage,
        userProfileResources: UserProfileResourcePackage,
        newsController: ILatestNewsController,
        options: NewsItemFixOptions,
        cancellationToken: CancellationToken
    ) {
        super(
            id,
            newsResources,
            userProfileResources,
            newsResources.assets_views_latest_news_news_tooltip_blue_png,
            newsResources.assets_views_latest_news_news_token_upgrade_png,
            options.playerAvatarTexture
        );
        this.options = options;
        this.newsController = newsController;
        this.cancellationToken = cancellationToken;
        this.build();
        this.layout();
        this.learnMoreButtonText.on("pointerdown", this.onLearnMoreClickHandle, this);
    }

    private build(): void {
        this.youEarnedText = new Text(NewsItemFixed.YOUVE_EARNED_TEXT, new NewsTextStyle());
        this.currencyComponent = new NewsCurrencyComponent(this.newsResources, this.options.currencyNumber, CurrencyType.TOKEN);
        this.forYourLastText = new Text(NewsItemFixed.FOR_YOUR_TEXT, new NewsTextStyle());
        this.learnMoreButtonText = new TextWithUnderline(NewsItemFixed.LEARN_MORE_TEXT, new NewsTextStyle(), 0, -12, 3);
        this.learnMoreButtonText.eventMode = 'static';
        this.avatar.updateTexture(this.options.playerAvatarTexture);

        this.addChild(this.youEarnedText, this.currencyComponent, this.forYourLastText, this.learnMoreButtonText);
    }

    private layout(): void {
        this.youEarnedText.position.set(411, 67);
        this.currencyComponent.position.set(this.youEarnedText.position.x + this.youEarnedText.width + 5, 67);
        this.forYourLastText.position.set(411, 105);
        this.learnMoreButtonText.position.set(411, 143);
    }

    private async onLearnMoreClickHandle(): Promise<void> {
        this.learnMoreButtonText.eventMode = 'auto';
        await this.newsController.updateLatestNewsInfo(this.id);
        await this.newsController.showUpgradeItem(this.options.currencyNumber.toString(), this.cancellationToken);
        this.learnMoreButtonText.eventMode = 'static';
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.learnMoreButtonText.off("pointerdown", this.onLearnMoreClickHandle, this);
        super.destroy(options);
    }
}

export class NewsItemFixOptions implements INewsItemOptions {
    public readonly playerAvatarTexture: Texture;
    public readonly currencyNumber: number;

    public constructor(playerAvatarTexture: Texture, currencyNumber: number) {
        this.playerAvatarTexture = playerAvatarTexture;
        this.currencyNumber = currencyNumber;
    }
}
